import { configureStore } from '@reduxjs/toolkit';
import { persistStore, PERSIST, REGISTER } from 'redux-persist';
import { psapInfoListener } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoMiddleware';
import { rsosApi } from '@rsos/reduxDataStore/src/features/rsosApi';
import reducer from '../reducers';

// The consolidated admin app intentionally does NOT persist or rehydrate Redux
// state. Every section fetches its own data on mount behind an AppLoading gate,
// so rehydrating slices from a previous session only caused bugs: most notably
// a section's `initialized` flag rehydrating true before the current session
// had fetched the data that section renders (e.g. navigating to Access from a
// different admin page rendered UsersManagement against empty sinatra
// management). Auth is unaffected — tokens live in localStorage (see
// shared/sinatra/src/utils/tokens.js), not in persisted Redux state.
//
// persistStore is still created so the shared logout helpers (onLogout, reached
// via ErrorPage and onSAMLrequest) and Layout receive a real Persistor; with no
// persistReducer registered its flush()/purge() are no-ops. Keeping the
// Persistor here (rather than threading a new no-persistence path through those
// shared components) keeps this consolidation's diff small.
// TODO: drop redux-persist from the admin app entirely as a follow-up — remove
// this persistor and the persistor prop from the section App components,
// ErrorPage, onSAMLrequest, and Layout once those shared helpers no longer
// require it.
export const store = configureStore({
  reducer,
  // getDefaultMiddleware already includes redux-thunk; rsosApi powers the
  // RTK Query endpoints the communication section uses, and psapInfoListener
  // configures phone utils when the active PSAP changes.
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      // persistStore dispatches PERSIST/REGISTER carrying non-serializable
      // callbacks; ignore them in the serializable check.
      serializableCheck: {
        ignoredActions: [PERSIST, REGISTER],
      },
    }).concat(rsosApi.middleware, psapInfoListener.middleware),
});
export const persistor = persistStore(store);
export type AdminDispatch = typeof store.dispatch;
